<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/messages.json"></i18n>

<template>
  <el-card shadow="hover">
    <div slot="header" class="clearfix">
      <el-row
        type="flex"
        class="row-bg align-center"
        :justify="val.gravatar ? 'space-between' : 'end'"
      >
        <v-gravatar v-if="val.gravatar" :size="35" :email="val.gravatar" />
        <el-button-group>
          <template v-for="(v, k) in val.actions">
            <template v-if="showBtn(v)">
              <template v-if="$slots[`actions.before.${k}`]">
                <slot :name="`actions.before.${k}`" />
              </template>
              <el-button
                :key="'btn' + k"
                :disabled="editMode && !cur_edit_mode"
                v-bind="v.props"
                @click="handleAction(val.actions[k].handler, k, val)"
              >
                {{ $t("actions." + k) }}
                <template v-if="v.button_els">
                  <component
                    v-for="(el, i) in v.button_els"
                    :is="el"
                    :key="i"
                  />
                </template>
              </el-button>
              <template v-if="$slots[`actions.after.${k}`]">
                <slot :name="`actions.after.${k}`" />
              </template>
            </template>
          </template>
        </el-button-group>
      </el-row>
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="Info" name="info" lazy>
        <el-form label-width="90px">
          <template v-for="(v, k) in val.schema">
            <el-form-item :key="k" :_label="k" v-if="!v.hidden">
              <template slot="label">
                <span
                  v-text="k"
                  @click="handleCopyToClipboard(val[k], k)"
                  style="cursor: copy"
                />
              </template>
              <template v-if="v.type === Boolean">
                <el-checkbox
                  :disabled="!cur_edit_mode || !v.editable"
                  v-model="val[k]"
                />
              </template>
              <template v-else>
                <span
                  v-text="
                    v.props && v.props['show-password'] && val[k]
                      ? '•••'
                      : val[k]
                  "
                  v-if="!cur_edit_mode || !v.editable"
                ></span>
                <el-input
                  v-model="val[k]"
                  v-else-if="v.editable"
                  v-bind="v.props"
                ></el-input>
              </template>
            </el-form-item>
          </template>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        label="Licenses"
        name="licenses"
        :disabled="!val.licenses || cur_edit_mode"
        v-if="val.uuid"
        lazy
      >
        <el-form label-width="140px">
          <el-form-item label="confirmed">
            <el-checkbox :disabled="true" v-model="val.confirmed" />
          </el-form-item>
          <el-divider></el-divider>
          <template v-for="(v, k) in val.licenses">
            <el-form-item
              :label="k"
              :key="k"
              v-if="
                ![
                  'sharedAmocrmLicensesCost_uuid',
                  'created_at',
                  'updated_at'
                ].includes(k)
              "
            >
              <el-checkbox
                v-if="typeof v === 'boolean'"
                :disabled="true"
                v-model="val.confirmed"
              />
              <span v-else-if="!(v instanceof Object)" v-text="v"></span>
              <span v-else>
                <template
                  v-for="f in Object.keys(v)
                    .filter(ff => ff.startsWith('max_'))
                    .map(ff => ff.split('_')[1])"
                >
                  <el-progress-custom
                    text-inside
                    :stroke-width="26"
                    :key="f"
                    :label="f"
                    v-bind="
                      (function() {
                        if (v['current_' + f] / v['max_' + f] < 1) {
                          return {};
                        }
                        return { status: 'warning' };
                      })()
                    "
                    :percentage="
                      Math.min(100, (v['current_' + f] / v['max_' + f]) * 100)
                    "
                    :format="
                      function() {
                        return v['current_' + f] + ' / ' + v['max_' + f];
                      }
                    "
                  ></el-progress-custom>
                </template>
              </span>
            </el-form-item>
          </template>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Statistic" name="statistic" v-if="val.uuid" lazy>
        <el-form label-width="100px">
          <el-form-item label="amo_users">
            <span v-text="val.sharedCustomersUsers.length"></span>
          </el-form-item>
          <el-form-item label="amo_widgets">
            <div>
              <span
                v-text="
                  val.sharedCustomersWidgets.filter(w => !w.isFKWidget).length
                "
              ></span>
              <router-link
                :to="{ name: 'amo_widgets', query: { amo_uuid: val.uuid } }"
                >View</router-link
              >
            </div>
          </el-form-item>
          <el-form-item label="fk_widgets">
            <span
              v-text="
                val.sharedCustomersWidgets.filter(w => w.isFKWidget).length
              "
            ></span>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane
        label="Users"
        name="users"
        :disabled="!val.sharedCustomersUsers.length"
        v-if="val.uuid"
        lazy
      >
        <el-table
          :data="val.sharedCustomersUsers"
          v-if="val.sharedCustomersUsers.length"
        >
          <el-table-column width="50">
            <template slot-scope="scope">
              <v-gravatar :size="35" :email="scope.row.email" />
            </template>
          </el-table-column>
          <el-table-column
            v-for="(v, k) in val.sharedCustomersUsers[0].schema"
            :key="v.uuid"
            :prop="k"
            :label="k"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-if="v.type === Boolean"
                :disabled="true"
                v-model="scope.row[k]"
              />
              <template v-else>
                {{ scope.row[k] }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import ElProgressCustom from "./el-progress-custom/el-progress-custom";

export default {
  name: "sub-element",
  components: { ElProgressCustom },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value,
      cur_edit_mode: false,
      activeName: "info"
    };
  },
  watch: {
    val: {
      handler: function() {
        this.$emit("input", this.val);
      },
      deep: true
    },
    cur_edit_mode(v) {
      this.$emit("update:editMode", v);
    }
  },
  methods: {
    handleAction(handler, action_name, model) {
      let h = handler();
      if (h instanceof Promise) {
        h.then(param => {
          switch (param) {
            case "edit":
              this.activeName = "info";
              this.cur_edit_mode = true;
              break;
            default:
              this.$emit("action", action_name, param, model);
              this.cur_edit_mode = false;
          }
          this.$emit("update:editMode", this.cur_edit_mode);
        });
      }
    },
    showBtn(v) {
      return this.cur_edit_mode === v.in_edit_mode;
    },
    handleCopyToClipboard(v, k) {
      this.$copyText(v);
      this.$notify({
        type: "info",
        message: `"${k}" copied to clipboard`
      });
    }
  }
};
</script>

<style scoped lang="stylus">
.card-contact, .card-amo, .card-customer {
    min-width: 400px;
    display: flex;
    flex-direction: column;
    margin-bottom: 2rem;
}

.row-bg {
    flex-wrap: wrap;
}
</style>
